module.exports = __webpack_public_path__ + "img/website.ad7df549.svg";